import { render, staticRenderFns } from "./VentanaOperacionesViajes.vue?vue&type=template&id=08f4793c"
import script from "./VentanaOperacionesViajes.vue?vue&type=script&lang=js"
export * from "./VentanaOperacionesViajes.vue?vue&type=script&lang=js"
import style0 from "./VentanaOperacionesViajes.vue?vue&type=style&index=0&id=08f4793c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports